import { createContext } from 'react';

export type DiffAnalytics = {
  onPageLoad: () => void;
  featureFlagSelectors?: { name: string; selector: any }[];
};

const defaultAnalytics: DiffAnalytics = {
  onPageLoad: () => {},
  featureFlagSelectors: [],
};

export const DiffAnalyticsContext = createContext(defaultAnalytics);
